export const vaccineDeases = [
  { id: 1, name: "Adenovirus infection" },
  { id: 2, name: "Anthrax" },
  { id: 3, name: "Pertussis (Whooping cough)" },
  { id: 4, name: "Chikungunya" },
  { id: 5, name: "Tetanus" },
  { id: 6, name: "Diphtheria" },
  { id: 7, name: "Dengue fever" },
  { id: 8, name: "Ebola" },
  { id: 9, name: "Haemophilus influenzae type b diseases" },
  { id: 11, name: "Hepatitis B" },
  { id: 12, name: "Hepatitis A" },
  { id: 13, name: "Cervical intraepithelial neoplasia (CIN); Genital warts" },
  { id: 14, name: "Seasonal Influenza" },
  { id: 15, name: "Pandemic Influenza" },
  { id: 16, name: "Japanese Encephalitis" },
  { id: 17, name: "Measles" },
  { id: 18, name: "Mpox" },
  { id: 19, name: "Mumps" },
  { id: 20, name: "Tuberculosis (TB)" },
  { id: 21, name: "Meningococcal disease" },
  { id: 22, name: "Malaria" },
  { id: 23, name: "Polio" },
  { id: 24, name: "Rabies" },
  { id: 25, name: "Respiratory Syncytial Virus (RSV) diseases" },
  { id: 26, name: "Rotavirus disease" },
  { id: 27, name: "Rubella" },
  { id: 28, name: "Typhoid fever (Enteric fever)" },
  { id: 29, name: "COVID-19" },
  { id: 30, name: "Streptococcus pneumoniae diseases" },
  { id: 31, name: "Tick-borne Encephalitis" },
  { id: 32, name: "Chickenpox (Varicella)" },
  { id: 33, name: "Shingles (Herpes zoster)" },
  { id: 34, name: "Smallpox" },
  { id: 35, name: "Cholera" },
  { id: 36, name: "Yellow Fever" }
].sort((a, b) => a.name.localeCompare(b.name));

